import apiService from './api';
import type { ApiResponse } from '../types';
import type { LegacyImportPreview, LegacyImportResult } from '../types/legacyImport';

/**
 * TEMPORARY: the legacy customer import is switched off at the start of this
 * day (Melbourne) here, in the backend and in the legacy export page, and all
 * three are to be deleted then.
 */
export const LEGACY_IMPORT_ENDS = '2026-10-28T00:00:00+11:00';

export function isLegacyImportOpen(now = Date.now()): boolean {
  return now < Date.parse(LEGACY_IMPORT_ENDS);
}

// The backend asks the legacy server, which can take a while.
const SLOW = { timeout: 60_000 };

class LegacyImportService {
  /** What importing (or, with customerId, syncing) would do. Writes nothing. */
  async preview(custNo: string, customerId?: number | null): Promise<ApiResponse<LegacyImportPreview>> {
    const q = customerId ? `?customer_id=${customerId}` : '';
    return apiService.get(`/nursery/legacy-customers/${encodeURIComponent(custNo)}/preview${q}`, SLOW);
  }

  /** matches: legacy stock item number → "s:<stock item id>" or "p:<product id>", chosen by hand. */
  async import(
    custNo: string,
    matches: Record<number, string>,
    customerId?: number | null,
  ): Promise<ApiResponse<LegacyImportResult>> {
    return apiService.post(
      `/nursery/legacy-customers/${encodeURIComponent(custNo)}/import`,
      { matches, customer_id: customerId ?? null },
      undefined,
      SLOW,
    );
  }
}

export default new LegacyImportService();
